<template>
    <div id="myOrders">
        <div style="width: 90%;">
            <patternlib-headline :headline="$t('myOrders.headline')" separator="none" heading-tag="h2">
            </patternlib-headline>
            <p
                style="
                    margin-top: var(--spacing-4);
                    margin-bottom: var(--spacing-6);
                "
            >{{ $t("myOrders.text") }}</p>
            <patternlib-accordion>
                <patternlib-accordion-item
                    v-for="(order, index) in globalStore.orders"
                    :label="`${$t('myOrders.ordernumber')}${order.orderNumber} | ${ new Date(order.date).toLocaleString(undefined, {year: 'numeric', month: '2-digit', day: '2-digit'}) }`"
                    :is-open = "(index == 0)"
                >
                <p><b>{{ $t("myOrders.state.text") + $t(`myOrders.state.${order.state}`) }}</b></p>
                <Article
                    v-for="(product, index) in order.products"
                    :pictureSRC="product.pictureSRC"
                    :amount="product.amount"
                    :name="product.name"
                    :price="`${order.currencyCode} ${product.price.toFixed(2)}`"
                    :articleStatus="product.articleStatus"
                    :shippingMethod="product.shippingMethod"
                    :packetStatus="product.packetStatus"
                ></Article>
                <div id="orderSummary">
                    <div style="flex-grow: 1; margin-top: var(--spacing-6);">
                        <patternlib-headline
                            :headline="$t('myOrders.orderSummary.paymentInfo')"
                            heading-tag="h3"
                            separator="none"
                        ></patternlib-headline>

                        <p style="margin-top: var(--spacing-5);"><b>{{ $t("myOrders.orderSummary.paymentType") }}</b></p>
                        <p style="margin-top: var(--spacing-xxxs);">{{ order.payment.paymentType }}</p>

                        <p style="margin-top: var(--spacing-5);"><b>{{ $t("myOrders.orderSummary.paymentAddress") }}</b></p>
                        <p style="margin-top: var(--spacing-xxxs);">{{ `${order.payment.paymentAddress.firstname} ${order.payment.paymentAddress.lastname}` }}</p>
                        <p>{{ order.payment.paymentAddress.street }}</p>
                        <p>{{ `${order.payment.paymentAddress.postalCode} ${order.payment.paymentAddress.city}` }}</p>
                        <p>{{ $t(`country.${order.payment.paymentAddress.countryId}`) }}</p>
                    </div>

                    <div style="flex-grow: 1; margin-top: var(--spacing-6);">
                        <patternlib-headline
                            :headline="$t('myOrders.orderSummary.shipment')"
                            heading-tag="h3"
                            separator="none"
                        ></patternlib-headline>

                        <!--
                        -- HRMIT-27244: disabled because of non sense data --
                        <p style="margin-top: var(--spacing-5);"><b>{{ $t("myOrders.orderSummary.shipmentType") }}</b></p>
                        <p style="margin-top: var(--spacing-xxxs);">{{ order.shipping.shippingType }}</p>
                        -->

                        <p style="margin-top: var(--spacing-5);"><b>{{ $t("myOrders.orderSummary.shipmentAddress") }}</b></p>
                        <p style="margin-top: var(--spacing-xxxs);">{{ `${order.shipping.shippingAddress.firstname} ${order.shipping.shippingAddress.lastname}` }}</p>
                        <p>{{ order.shipping.shippingAddress.street }}</p>
                        <p>{{ `${order.shipping.shippingAddress.postalCode} ${order.shipping.shippingAddress.city}` }}</p>
                        <p>{{ $t(`country.${order.shipping.shippingAddress.countryId}`) }}</p>
                    </div>

                    <div style="flex-grow: 1; margin-top: var(--spacing-6);">
                        <patternlib-headline
                            :headline="$t('myOrders.orderSummary.total')"
                            heading-tag="h3"
                            separator="none"
                        ></patternlib-headline>

                        <table style="margin-top: var(--spacing-5);">
                            <tr>
                                <td style="padding-right: var(--spacing-6);">{{ $t("myOrders.orderSummary.subtotal") }}</td>
                                <td>{{ `${order.currencyCode} ${order.subtotal.toFixed(2)}` }}</td>
                            </tr>
                            <tr>
                                <td style="padding-right: var(--spacing-6);">{{ $t("myOrders.orderSummary.shipmentcosts") }}</td>
                                <td>{{ `${order.currencyCode} ${order.shippingCharges.toFixed(2)}` }}</td>
                            </tr>
                            <tr>
                                <th style="padding-right: var(--spacing-6);">{{ $t("myOrders.orderSummary.total") }}</th>
                                <td>{{ `${order.currencyCode} ${order.total.toFixed(2)}` }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                </patternlib-accordion-item>
            </patternlib-accordion>
            <p v-if="globalStore.orders && globalStore.orders.length == 0">{{ $t('myOrders.noOrders') }}</p>
        </div>
        <patternlib-spinner spin v-if="!globalStore.orders" style="justify-content: center;"></patternlib-spinner>
    </div>
</template>

<script>
  import Article from '../components/article.vue';
  import { useServices } from '../services/useServices';
  import { useGlobal } from '../stores/globalStore';

export default {
  data: () => ({
    intervallId: null
  }),

  components: {
    Article
},

    computed: {
      globalStore: () => useGlobal()
    },

  methods: {
    loadPictureUrl(services, product){
        if (product.pictureSRC == null){
            services.$api.getProductPictureUrl((data) => {product.pictureSRC = data ? data : ""}, product.articlenumber)
        }
    },

    loadPictureUrls(services, globalStore){
        let order
        let product
        for (order of globalStore.orders) {
            for (product of order.products) {
                this.loadPictureUrl(services, product)
            }
        }
    },

    loadOrders(services, globalStore){
        services.$api.getAllOrders((data) => {
            if (!globalStore.orders || (data.length != globalStore.orders.length)) {globalStore.orders = data}
            this.loadPictureUrls(services, globalStore)
        })
    }
  },

  created() {
    const services = useServices()
    const globalStore = useGlobal()

    this.loadOrders(services, globalStore)
    let enablePolling = (import.meta.env.VITE_POLLING_INTERVALL > 5)
    if (enablePolling) {
        this.intervallId = setInterval(() => {this.loadOrders(services, globalStore)}, import.meta.env.VITE_POLLING_INTERVALL * 1000)
    }
  },

  unmounted() {
    clearInterval(this.intervallId)
  },
};
</script>

<style lang="scss" scoped>
#myOrders {
    display: flex;
    flex-direction: column;
    align-items: center;
}

#orderSummary {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
}

@media only screen and (max-width: 770px) { 
    #orderSummary {
        flex-direction: column;
    }
}
</style>